import React from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { capitalise } from '../../../services/text/format';
import { useGetAiFeedback } from '../../../services/api/generated/client';
import { FIVE_MIN_STALE_TIME } from '../../../services/api/query/queryClient';
import { unwrapModel } from '../../../services/api/unwrapModel';
import AiAssistRating from './AiAssistRating';
const AiAssistRatingWrapper = ({ handleExpand, model, type, context, }) => {
    const capitalised = capitalise(type);
    const feedbackableType = `App\\Models\\${capitalised}`;
    const { data: response, refetch, isError, isLoading, } = useGetAiFeedback({
        feedbackable_id: model.id,
        feedbackable_type: feedbackableType,
        ai_feedback_context_id: context,
    }, {
        query: {
            staleTime: FIVE_MIN_STALE_TIME,
            placeholderData: keepPreviousData,
        },
    });
    const feedback = unwrapModel(response);
    if (isError)
        return null;
    if (isLoading && !feedback)
        return null;
    return (React.createElement(AiAssistRating, { model: model, handleExpand: handleExpand, onSubmitFeedback: refetch, type: type, feedback: feedback }));
};
export default React.memo(AiAssistRatingWrapper);
